import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { militaryPayTax_template } from "../components/templates/militaryPayTax_template";
import { header } from "./header";

declare var ko: any;

export class military_pay_tax extends vnModule_knockoutJS {

    protected militaryPayTaxForm: militaryPayTax_template;

    buildContent(): Array<Element> {
        this.militaryPayTaxForm = new militaryPayTax_template("militaryPayTaxTemplate", this.viewModel, this);

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        if (loadedModule && typeof (loadedModule as header).setHeaderTitle === "function") {
            (loadedModule as header).setHeaderTitle("Military Pay Tax Config");
        }

        return [this.militaryPayTaxForm.build()];
    }

    protected getModuleName(): string {
        return "military_pay_tax";
    }

    public fillPage(): void {
        this.loadingIn(this.militaryPayTaxForm.builtTemplate);
        this.setSaveStatus("Loading...");

        this.getSavedConfig().then((tax) => {
            this.militaryPayTaxForm.setJson(tax);
            this.setSaveStatus("");
            this.loadingOut(this.militaryPayTaxForm.builtTemplate);
        }).catch((err: Error) => {
            this.setSaveStatus("Error: " + (err.message || "Load failed"));
            this.loadingOut(this.militaryPayTaxForm.builtTemplate);
        });
    }

    protected filterSimpleOnChange(idElement) {
    }

    public async save(): Promise<void> {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand == null || idBrand === undefined) {
            this.setSaveStatus("Error: brand not found");
            return;
        }

        let payload: object;
        try {
            payload = this.militaryPayTaxForm.getParsedJson();
        } catch (error) {
            this.setSaveStatus("Invalid JSON: " + (error && error.message ? error.message : "parse failed"));
            return;
        }

        const url = "/api/brand/" + idBrand + "/generalconfig/military-pay-tax/save/";
        this.setSaveStatus("Saving...");

        return fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
            body: JSON.stringify({ data: JSON.stringify(payload) }),
            credentials: "same-origin"
        }).then((res) => {
            if (!res.ok) {
                return res.json()
                    .then((err: { error?: string; message?: string }) => {
                        throw new Error(err.error || err.message || res.statusText);
                    })
                    .catch((err: Error) => {
                        if (err.message && err.message !== res.statusText) {
                            throw err;
                        }
                        throw new Error(res.statusText);
                    });
            }
            return res.json();
        }).then(() => {
            this.setSaveStatus("Saved!");
            setTimeout(() => this.setSaveStatus(""), 3000);
        }).catch((err: Error) => {
            this.setSaveStatus("Error: " + (err.message || "Save failed"));
        });
    }

    public getSavedConfig(): Promise<object> {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand == null || idBrand === undefined) {
            return Promise.reject(new Error("Brand not found"));
        }

        const url = "/api/brand/" + idBrand + "/generalconfig/military-pay-tax/get/";

        return fetch(url, {
            method: "GET",
            headers: { "X-Requested-With": "XMLHttpRequest" },
            credentials: "same-origin"
        }).then((res) => {
            if (!res.ok) {
                throw new Error(res.statusText);
            }
            return res.json();
        }).then((body) => {
            const data = body && body.data ? body.data : body;
            return data && data.tax ? data.tax : {};
        });
    }

    private setSaveStatus(status: string): void {
        if (this.militaryPayTaxForm) {
            this.militaryPayTaxForm.setSaveStatus(status);
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_pay_tax.ts